import { render } from "./RolesOverview.vue?vue&type=template&id=3173e8a8"
import script from "./RolesOverview.vue?vue&type=script&lang=js"
export * from "./RolesOverview.vue?vue&type=script&lang=js"

import "./RolesOverview.vue?vue&type=style&index=0&id=3173e8a8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__